<template>
  <EmailsChart :start-date="startDate" />
</template>
<script setup lang="ts">
import EmailsChart from "./EmailsChart.vue";

defineProps<{
  startDate: string;
  tier: string;
}>();
</script>
